/**
 * Owner-only room-config changes (e.g. archive mode) are authorized with a
 * deterministic EIP-191 signature: only the holder of the room wallet key can
 * produce it, so the relay can verify "this toggle really comes from the room
 * owner" without any server-side account state. Must stay byte-identical to
 * buildRoomConfigAuthMessage in upload-orchestrator/src/websocket/chatHandler.js.
 */
export function buildRoomConfigAuthMessage(room, archiveEnabled, timestamp) {
    return `Dwinity room config\nroom: ${room.toLowerCase()}\narchive: ${archiveEnabled ? 'on' : 'off'}\nts: ${timestamp}`;
}
export function buildChatClearAuthMessage(room, generation, timestamp) {
    return `Dwinity clear common chat\nroom: ${room.toLowerCase()}\ngeneration: ${generation}\nts: ${timestamp}`;
}
